import { render, staticRenderFns } from "./FinanceStatementsDashboard.vue?vue&type=template&id=9fc965e2&scoped=true&"
import script from "./FinanceStatementsDashboard.vue?vue&type=script&lang=js&"
export * from "./FinanceStatementsDashboard.vue?vue&type=script&lang=js&"
import style0 from "./FinanceStatementsDashboard.vue?vue&type=style&index=0&id=9fc965e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fc965e2",
  null
  
)

export default component.exports